import React from "react";
import FocusTrapping from "../__hoc/FocusTrapping";
import { LoginModal } from "../LoginModal/LoginModal";
import { EmailLoginModal } from "../EmailLoginModal/EmailLoginModal";
import { OTPModal } from "../OTPModal/OTPModal";

interface AuthModalsProps {
	isLoginModalOpen?: boolean;
	isEmailLoginModalOpen: boolean;
	isEmailOtpModalOpen: boolean;
	onLoginModalClose: () => void;
	onEmailLoginModalClose: (isOpen: boolean) => void;
	onOtpModalClose: (isOpen: boolean) => void;
}

export const AuthModals: React.FC<AuthModalsProps> = ({
	isLoginModalOpen,
	isEmailLoginModalOpen,
	isEmailOtpModalOpen,
	onLoginModalClose,
	onEmailLoginModalClose,
	onOtpModalClose,
}) => (
	<>
		{/* Login Modal */}
		{isLoginModalOpen && (
			<FocusTrapping
				onHandleClose={onLoginModalClose}
				isActive={isLoginModalOpen}
				modalId="login-modal"
			>
				<LoginModal
					headertestid="loginmodal-onclose-button"
					show={isLoginModalOpen}
					onClose={onLoginModalClose}
				/>
			</FocusTrapping>
		)}

		{/* Email Login Modal */}
		{isEmailLoginModalOpen && (
			<FocusTrapping
				onHandleClose={() => onEmailLoginModalClose(false)}
				isActive={isEmailLoginModalOpen}
				modalId="email-login-modal"
			>
				<EmailLoginModal
					isOpen={isEmailLoginModalOpen}
					setIsOpen={onEmailLoginModalClose}
				/>
			</FocusTrapping>
		)}

		{/* OTP Modal */}
		{isEmailOtpModalOpen && (
			<FocusTrapping
				onHandleClose={() => onOtpModalClose(false)}
				isActive={isEmailOtpModalOpen}
				modalId="otp-modal"
			>
				<OTPModal isOpen={isEmailOtpModalOpen} setIsOpen={onOtpModalClose} />
			</FocusTrapping>
		)}
	</>
);
